/**
 * Take in an object and an array of keys and return a new object with only the keys specified, all as string values
 */
export function numberFields({ obj, fields }: { obj: any; fields: string[] }): { [key: string]: number } {
  return Object.fromEntries(
    fields
      .map((field) => (obj[field] && !isNaN(Number(obj[field])) ? [field, Number(obj[field])] : null))
      .filter(Boolean)
  )
}
